import { useTranslation } from 'react-i18next';

import { LoadingAnimation } from 'shared/components';

export const Loading = () => {
    const { t } = useTranslation();
    return <LoadingAnimation text={t('loading')} />;
};
